// MUI
import { Box, Typography, Button, Stack } from '@mui/material';

// Third party
import { useNavigate } from 'react-router-dom';

const NotFoundPage = ({ showForData }: { showForData?: boolean; }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: showForData ? '80vh' : '100vh',
        backgroundColor: showForData ? '' : '#0E1720',
        display: 'grid',
        placeItems: 'center',
        px: 2,
        position: 'relative',
        overflow: 'hidden',
        '&:before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: showForData ? '' :
            ` radial-gradient(800px 500px at 20% 10%, rgba(0,224,255,0.08), transparent 60%),
             radial-gradient(700px 500px at 90% 90%, rgba(29,176,191,0.10), transparent 60%)`,
          pointerEvents: 'none',
        },
      }}
    >
      <Box
        sx={{
          width: 'min(960px, 92vw)',
          borderRadius: '5px',
          p: { xs: 3, sm: 5 },
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1.2fr' },
          gap: 4,
          alignItems: 'center',
          color: '#fff',
          position: 'relative',
        }}
      >
        {/* Image side */}
        <Box sx={{ display: 'grid', placeItems: 'center', position: 'relative' }}>
          <Box
            sx={{
              position: 'absolute',
              width: 360,
              height: 360,
              borderRadius: '50%',
            }}
          />
          <Box
            component="img"
            src="/NotFound.png"
            sx={{
              width: { xs: 260, sm: 300, md: 320 },
              height: { xs: 260, sm: 300, md: 320 },
              objectFit: 'cover',
              borderRadius: '50%',
              boxShadow:
                '0 10px 30px rgba(0,0,0,0.5), 0 0 0 10px rgba(0,224,255,0.10), inset 0 0 40px rgba(0,224,255,0.10)',
            }}
          />
        </Box>

        {/* Text side */}
        <Stack spacing={3} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
          <Typography variant="h5" sx={{ color: '#FFFFFF', fontWeight: 700 }}>
            Page not found
          </Typography>

          <Typography sx={{ color: '#A6B1C2' }}>
            The page you’re looking for doesn’t exist, was moved, or is temporarily unavailable.
          </Typography>

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            sx={{ mt: 2, justifyContent: { xs: 'center', md: 'flex-start' } }}
          >
            <Button
              onClick={() => navigate('/')}
              variant="contained"
              sx={{
                backgroundColor: '#1DB0BF',
                px: 3.5,
                py: 1.2,
                fontWeight: 'bold',
                textTransform: 'none',
                borderRadius: '5px',
                '&:hover': { backgroundColor: '#1D6F78' },
              }}
            >
              Go Home
            </Button>

            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              sx={{
                color: '#00E0FF',
                borderColor: '#00E0FF',
                px: 3.5,
                py: 1.2,
                fontWeight: 'bold',
                textTransform: 'none',
                borderRadius: '5px',
                '&:hover': {
                  borderColor: '#1D6F78',
                },
              }}
            >
              Go Back
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default NotFoundPage;
